import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/food"

export const getAllFoods = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getFood = async (foodId) => {
  const response = await farasod.get(`${endpoint}/${foodId}`)

  return response.data
}

export const getLinkedFoods = async (extraFoodId) => {
  const response = await farasod.get(`${endpoint}/extra/multiple/${extraFoodId}`)

  return response.data
}

export const editLinkedFoods = async (extraFoodId, data) => {
  const response = await farasod.patch(`${endpoint}/extra/multiple/${extraFoodId}`, data)

  return response.data
}

export const addFood = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editFood = async (data, foodId) => {
  const response = await farasod.patch(`${endpoint}/${foodId}`, data)

  return response.data
}

export const deleteFood = async (foodId) => {
  const response = await farasod.delete(`${endpoint}/${foodId}`)

  return response.data
}

export const addFoodOption = async (foodId, data) => {
  const response = await farasod.post(`${endpoint}/${foodId}/option`, data)

  return response.data
}

export const editFoodOption = async (foodId, optionId, data) => {
  const response = await farasod.patch(`${endpoint}/${foodId}/option/${optionId}`, data)

  return response.data
}

export const deleteFoodOption = async (foodId, optionId) => {
  const response = await farasod.delete(`${endpoint}/${foodId}/option/${optionId}`)

  return response.data
}

export const linkSpecificationToFood = async (specificationId, data) => {
  const response = await farasod.patch(`${endpoint}/specification/multiple/${specificationId}`, data)

  return response.data
}

export const getSpecificationLinkedFoods = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/specification/multiple?${query}`)

  return response.data
}

export const getFoodTemplate = async () => {
  const response =
    await farasod.get(`${endpoint}/bulk/data`, {
      responseType: "arraybuffer"
    })

  return response
}

export const getInventoryTemplate = async (branchId) => {
  const response =
    await farasod.get(`${endpoint}/bulk/inventory/data/${branchId}`, {
      responseType: "arraybuffer"
    })

  return response
}

export const addFoodsInBulk = async (data, onUploadProgress, source = { token: null }) => {
  const response =
    await farasod.post(`${endpoint}/bulk/data`, data, {
      cancelToken: source.token,
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress
    })

  return response.data
}

export const addInventoriesInBulk = async (branchId, data, onUploadProgress, source = { token: null }) => {
  const response =
    await farasod.post(`${endpoint}/bulk/inventory/data/${branchId}`, data, {
      cancelToken: source.token,
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress
    })

  return response.data
}

export const addFoodInventory = async (foodId, optionId, data) => {
  const response =
    await farasod.patch(`${endpoint}/${foodId}/option/${optionId}/inventory`, data)

  return response.data
}

export const changeFoodPriceList = async (foodId, optionId, data) => {
  const response =
    await farasod.patch(`${endpoint}/price/${foodId}/${optionId}`, data)

  return response.data
}